<template>
  <div>
    <b-collapse :id="'collapse' + index">
      <b-card v-if="showDetails">
        <div class="regular-18 mb-3"><u>Member Information</u></div>
        <div class="custom-table-responsive">
          <table class="custom-table">
            <tbody>
              <tr>
                <td width="50%">
                  <tr>
                    <td><div class="text-muted regular-16">PID</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.member_information.pid }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Institution</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div v-if="showDetails.member_information.institution" class="regular-16 ml-2">
                        {{ showDetails.member_information.institution.name }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Accept Status</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div
                        v-if="showDetails.member_information.accepted_status.status"
                        class="regular-16 ml-2"
                      >
                        Accepted on :
                        {{ moment(showDetails.member_information.accepted_status.accepted_on, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY hh:mm a') }}
                      </div>
                      <div
                        v-else-if="!showDetails.member_information.accepted_status.status && showDetails.member_information.accepted_status.declined_on"
                        class="regular-16 ml-2"
                      >
                        Declined on :
                        {{ moment(showDetails.member_information.accepted_status.declined_on, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY hh:mm a') }}
                      </div>
                      <div
                        v-else
                        class="regular-16 ml-2"
                      >
                        --
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Acceptance Note</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.member_information.accepted_status.accepted_note ? showDetails.member_information.accepted_status.accepted_note : '--' }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Member Attributes</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        Allow Acceptance & Registration :
                        <b>{{ showDetails.member_information.member_attributes.allow_registration ? 'Yes' : 'No' }}</b>
                      </div>
                      <div class="regular-16 ml-2">
                        Allow Housing :
                        <b>{{ showDetails.member_information.member_attributes.allow_housing ? 'Yes' : 'No' }}</b>
                      </div>
                      <div class="regular-16 ml-2">
                        Allow Visa Registration :
                        <b>{{ showDetails.member_information.member_attributes.allow_visa ? 'Yes' : 'No' }}</b>
                      </div>
                      <div class="regular-16 ml-2">
                        Disable Exit Survey :
                        <b>{{ showDetails.member_information.member_attributes.disable_exit_survey ? 'Yes' : 'No' }}</b>
                      </div>
                      <div class="regular-16 ml-2">
                        Allow Exit Survey Period Exception :
                        <b>{{ showDetails.member_information.member_attributes.allow_exit_survey_period_exception ? 'Yes' : 'No' }}</b>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Member Role</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div v-if="showDetails.member_information.member_roles.length > 0" class="ml-2">
                        <span
                          v-for="(role, roleKey) in showDetails.member_information.member_roles" :key="roleKey"
                          class="regular-16"
                        >
                          {{ role }}<span v-if="roleKey < showDetails.member_information.member_roles.length -1">,</span>
                        </span>
                      </div>
                      <div v-else class="ml-2">
                        --
                      </div>
                    </td>
                  </tr>
                </td>
                <td width="50%">
                  <tr>
                    <td><div class="text-muted regular-16">Visits</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div
                        v-for="(memberVisit, visitKey) in showDetails.member_information.visits" :key="visitKey"
                        class="regular-16 ml-2"
                      >
                        <span>
                          {{ moment(memberVisit.estimated_arrival_date, 'YYYY-MM-DD').format('MMMM Do, YYYY') }} -
                          {{ moment(memberVisit.estimated_departure_date, 'YYYY-MM-DD').format('MMMM Do, YYYY') }}
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Invitation Date</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.member_information.invitation_date ? moment(showDetails.member_information.invitation_date, 'YYYY-MM-DD').format('MMMM Do, YYYY') : '--' }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Invitation Period</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.member_information.invitation_period ? showDetails.member_information.invitation_period : '--' }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Per DIEM Rate</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.member_information.per_diam_rate ? showDetails.member_information.per_diam_rate : '--' }}
                      </div>
                    </td>
                  </tr>
                  <!-- <tr>
                    <td><div class="text-muted regular-16">Per DIEM Monthly</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{showDetails.member_information.invitation_period ? showDetails.member_information.invitation_period : '--'}}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Per DIEM Max</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{showDetails.member_information.invitation_period ? showDetails.member_information.invitation_period : '--'}}
                      </div>
                    </td>
                  </tr> -->
                  <tr>
                    <td><div class="text-muted regular-16">Travel Max</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.member_information.travel_max ? showDetails.member_information.travel_max : '--' }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Notes</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2" v-html="showDetails.member_information.notes" />
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Funding Notes</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2" v-html="showDetails.member_information.funding_notes" />
                    </td>
                  </tr>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr>
        <div class="regular-18 mt-3 mb-3"><u>Registration Information</u></div>
        <div class="custom-table-responsive">
          <table class="custom-table">
            <thead>
              <tr>
                <th class="pb-2">Personal</th>
                <th class="pb-2">Highest Degree</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td width="50%">
                  <tr>
                    <td><div class="text-muted regular-16">Name</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.registration_information.personal.name ? showDetails.registration_information.personal.name : '--' }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">URL</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div v-if="showDetails.registration_information.personal.url" class="regular-16 ml-2">
                        <a :href="showDetails.registration_information.personal.url">
                          {{ showDetails.registration_information.personal.url }}
                        </a>
                      </div>
                      <div v-else class="regular-16 ml-2">
                        --
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Email</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div v-if="showDetails.registration_information.personal.email" class="regular-16 ml-2">
                        <a
                          :href="`mailto:${showDetails.registration_information.personal.email}`"
                        >
                          {{ showDetails.registration_information.personal.email }}
                        </a>
                      </div>
                      <div v-else class="regular-16 ml-2">
                        --
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Gender</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div v-if="showDetails.registration_information.personal.gender" class="regular-16 ml-2">
                        {{ showDetails.registration_information.personal.gender }}
                        <span v-if="showDetails.registration_information.personal.gender_explanation_text">
                          {{ showDetails.registration_information.personal.gender_explanation_text }}
                        </span>
                      </div>
                      <div v-else>--</div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Race</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="ml-2">
                        <span
                          v-for="(races, racesKey) in showDetails.registration_information.personal.races" :key="racesKey"
                          class="regular-16"
                        >
                          {{ races }}<span v-if="racesKey < showDetails.registration_information.personal.races.length -1">,</span>
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Citizenship</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="ml-2">
                        <span
                          v-for="(citizenship, citizenshipKey) in showDetails.registration_information.personal.citizenship" :key="citizenshipKey"
                          class="regular-16"
                        >
                          {{ citizenship }}<span v-if="citizenshipKey < showDetails.registration_information.personal.citizenship.length -1">,</span>
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Field of Expertise</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        <span v-if="showDetails.registration_information.personal.research_interest">
                          {{ showDetails.registration_information.personal.research_interest }}
                        </span>
                        <span v-else> -- </span>
                      </div>
                    </td>
                  </tr>
                </td>
                <td width="50%">
                  <tr>
                    <td><div class="text-muted regular-16">Degree</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.registration_information.highest_degree.degree ? showDetails.registration_information.highest_degree.degree : '--' }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Institution</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.registration_information.highest_degree.institution ? showDetails.registration_information.highest_degree.institution : '--' }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Department</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.registration_information.highest_degree.department ? showDetails.registration_information.highest_degree.department : '--' }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">School/Center/Other</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.registration_information.highest_degree.school_center_other ? showDetails.registration_information.highest_degree.school_center_other : '--' }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Year</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.registration_information.highest_degree.year ? showDetails.registration_information.highest_degree.year : '--' }}
                      </div>
                    </td>
                  </tr>
                  <tr v-if="checkNullAndEmptyValues(showDetails.registration_information.highest_degree.habilitation_year)">
                    <td>
                      <div class="text-muted regular-16">Habilitation Year</div>
                    </td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        <span v-if="checkNullAndEmptyValues(showDetails.registration_information.highest_degree.habilitation_year)">
                          {{ showDetails.registration_information.highest_degree.habilitation_year }}
                        </span>
                        <span v-else> -- </span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="checkNullAndEmptyValues(showDetails.registration_information.highest_degree.phd_year)">
                    <td>
                      <div class="text-muted regular-16">PhD Year</div>
                    </td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        <span v-if="checkNullAndEmptyValues(showDetails.registration_information.highest_degree.phd_year)">
                          {{ showDetails.registration_information.highest_degree.phd_year }}
                        </span>
                        <span v-else> -- </span>
                      </div>
                    </td>
                  </tr>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr>
        <div class="custom-table-responsive">
          <table class="custom-table">
            <thead>
              <tr>
                <th class="pb-2">Preferred Mailing Address</th>
                <th class="pb-2">Home Institution</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td width="50%">
                  <tr>
                    <td>
                      <span class="px-2 badge badge-pill badge-secondary">
                        <span class="regular-16 typo-color-white">
                          {{ showDetails.registration_information.preferred_mailing_address.type }}
                        </span>
                      </span>
                      <span v-if="showDetails.registration_information.preferred_mailing_address.institution_name" class="regular-16">
                        {{ showDetails.registration_information.preferred_mailing_address.institution_name }},
                        {{ showDetails.registration_information.preferred_mailing_address.institution_department }}
                      </span>
                      <span class="regular-16">
                        {{ showDetails.registration_information.preferred_mailing_address.street1 }},
                        <span v-if="showDetails.registration_information.preferred_mailing_address.street2">
                          {{ showDetails.registration_information.preferred_mailing_address.street2 }},
                        </span>
                        {{ showDetails.registration_information.preferred_mailing_address.city }}
                      </span>
                    </td>
                  </tr>
                </td>
                <td width="50%">
                  <tr>
                    <td><div class="text-muted regular-16">Institution</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.registration_information.home_institution.institution ? showDetails.registration_information.home_institution.institution : '--' }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Department</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.registration_information.home_institution.department ? showDetails.registration_information.home_institution.department : '--' }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">School/Center/Other</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.registration_information.home_institution.school_center_other ? showDetails.registration_information.home_institution.school_center_other : '--' }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Address</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        <span v-if="showDetails.registration_information.home_institution.address.street">
                          {{ showDetails.registration_information.home_institution.address.street }},
                        </span>
                        {{ showDetails.registration_information.home_institution.address.city }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Position</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.registration_information.home_institution.address.position ? showDetails.registration_information.home_institution.address.position : '--' }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td><div class="text-muted regular-16">Title</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.registration_information.home_institution.address.title ? showDetails.registration_information.home_institution.address.title : '--' }}
                      </div>
                    </td>
                  </tr>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr v-if="!mayUp"/>
        <div v-if="!mayUp" class="custom-table-responsive">
          <table class="custom-table">
            <thead>
              <tr>
                <th class="pb-2">
                  Visa
                  <a
                    v-if="showDetails.registration_information.visa && showDetails.registration_information.visa.id"
                    :href="fetchLegacyUrl(`/visas/${showDetails.registration_information.visa.id}/edit`)"
                  >
                    <i v-b-tooltip.hover.top class="fa fa-edit custom-fa-edit-color" title="Edit" />
                  </a>
                </th>
                <th class="pb-2">
                  Housing
                  <a
                    v-if="showDetails.registration_information.housing && showDetails.registration_information.housing.id"
                    :href="fetchLegacyUrl(`/housings/${showDetails.registration_information.housing.id}/edit`)"
                  >
                    <i v-b-tooltip.hover.top class="fa fa-edit custom-fa-edit-color" title="Edit" />
                  </a>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td width="50%">
                  <div v-if="showDetails.registration_information.visa">
                    <tr>
                      <td><div class="text-muted regular-16">Visa ID</div></td>
                      <td><div class="text-muted regular-16">:</div></td>
                      <td>
                        <div class="regular-16 ml-2">
                          <a v-if="showDetails.registration_information.visa.id" :href="fetchLegacyUrl(`/visas/${showDetails.registration_information.visa.id}`)">
                            {{ showDetails.registration_information.visa.id }}
                          </a>
                          <span v-else>--</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td><div class="text-muted regular-16">Requested Visa?</div></td>
                      <td><div class="text-muted regular-16">:</div></td>
                      <td>
                        <div class="regular-16 ml-2">
                          {{ showDetails.registration_information.visa.requested_visa ? 'Yes' : 'No' }}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td><div class="text-muted regular-16">Notes</div></td>
                      <td><div class="text-muted regular-16">:</div></td>
                      <td>
                        <div class="regular-16 ml-2" v-html="showDetails.registration_information.visa.notes" />
                      </td>
                    </tr>
                    <tr>
                      <td><div class="text-muted regular-16">Final Visa Status</div></td>
                      <td><div class="text-muted regular-16">:</div></td>
                      <td>
                        <div class="regular-16 ml-2">
                          {{ showDetails.registration_information.visa.final_visa_status ? showDetails.registration_information.visa.final_visa_status : '--' }}
                        </div>
                      </td>
                    </tr>
                  </div>
                  <div v-else>
                    <div class="regular-16 text-center text-muted py-2">
                      No Visa Application Information Found
                    </div>
                  </div>
                </td>
                <td width="50%">
                  <div v-if="showDetails.registration_information.housing">
                    <tr>
                      <td><div class="text-muted regular-16">Housing ID</div></td>
                      <td><div class="text-muted regular-16">:</div></td>
                      <td>
                        <div class="regular-16 ml-2">
                          <a v-if="showDetails.registration_information.housing.id" :href="fetchLegacyUrl(`/housings/${showDetails.registration_information.housing.id}`)">
                            {{ showDetails.registration_information.housing.id }}
                          </a>
                          <span v-else>--</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td><div class="text-muted regular-16">Requested Housing?</div></td>
                      <td><div class="text-muted regular-16">:</div></td>
                      <td>
                        <div class="regular-16 ml-2">
                          {{ showDetails.registration_information.housing.requested_housing ? 'Yes' : 'No' }}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td><div class="text-muted regular-16">Requested MSRI Assistance?</div></td>
                      <td><div class="text-muted regular-16">:</div></td>
                      <td>
                        <div class="regular-16 ml-2">
                          {{ showDetails.registration_information.housing.requested_msri_assistance ? 'Yes' : 'No' }}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td><div class="text-muted regular-16">Notes</div></td>
                      <td><div class="text-muted regular-16">:</div></td>
                      <td>
                        <div class="regular-16 ml-2" v-html="showDetails.registration_information.housing.notes" />
                      </td>
                    </tr>
                  </div>
                  <div v-else>
                    <div class="regular-16 text-center text-muted py-2">
                      No Housing Information Found
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr v-if="!mayUp" />
        <div v-if="!mayUp" class="custom-table-responsive">
          <table class="custom-table">
            <thead>
              <tr>
                <th class="pb-2">Anticipated MSRI Visits from Registration Form</th>
                <th class="pb-2">Email</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td width="50%">
                  <tr v-if="showDetails.member_information.visits.length < 1">
                    <td>No Visits Found</td>
                  </tr>
                  <tr v-else>
                    <td>
                      <ul>
                        <li v-for="(visit, i) in showDetails.member_information.visits" :key="i">
                          {{ visit.estimated_arrival_date ? moment(visit.estimated_arrival_date, 'YYYY-MM-DD').format('MMMM Do, YYYY') : '--' }} -
                          {{ visit.estimated_departure_date ? moment(visit.estimated_departure_date, 'YYYY-MM-DD').format('MMMM Do, YYYY') : '--' }}
                        </li>
                      </ul>
                    </td>
                  </tr>
                </td>
                <td width="50%">
                  <tr>
                    <td><div class="text-muted regular-16">Requested?</div></td>
                    <td><div class="text-muted regular-16">:</div></td>
                    <td>
                      <div class="regular-16 ml-2">
                        {{ showDetails.registration_information.msri_email_requested.msri_email ? 'Yes' : 'No' }}
                      </div>
                    </td>
                  </tr>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
      <b-card v-else>
        <div class="regular-16 text-center text-muted py-2">
          No Details Found
        </div>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
import mixin from "@/utils/mixin.js"

export default {
	name: "MemberShowDetailSection",
	mixins: [mixin],
	props: ["index", "showDetails", "mayUp"],
}
</script>

<style scoped lang="scss">
.custom-table {
  width: 100%;
  border-collapse: separate !important;
  border-spacing: 3px;
  td {
    vertical-align: top !important;
  }
}
.custom-table-responsive {
  overflow-x:auto !important;
}
</style>
